/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/forms';
import * as i2 from '../../../ui/settings/scenario.component';
import * as i3 from '@angular/common';
const styles_ScenarioComponent:any[] = ([] as any[]);
export const RenderType_ScenarioComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ScenarioComponent,data:{}});
function View_ScenarioComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),3,'option',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i0.ɵdid(147456,
      (null as any),0,i1.NgSelectOption,[i0.ElementRef,i0.Renderer2,[2,i1.SelectControlValueAccessor]],
      {ngValue:[0,'ngValue']},(null as any)),i0.ɵdid(147456,(null as any),0,i1.ɵq,
      [i0.ElementRef,i0.Renderer2,[8,(null as any)]],{ngValue:[0,'ngValue']},(null as any)),
      (_l()(),i0.ɵted((null as any),['','']))],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_1);
  },(_ck,_v) => {
    const currVal_2:any = _v.context.$implicit.getName();
    _ck(_v,3,0,currVal_2);
  });
}
export function View_ScenarioComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),27,'div',[['class',
      'settings-block']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'h6',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['Scenario'])),(_l()(),i0.ɵted((null as any),
          ['\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),9,'select',[['class',
          'select'],['style','width: 180px;'],['title','select a scenario']],[[2,'ng-untouched',
          (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
          [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
              (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],
          [(null as any),'change'],[(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.ScenarioComponent = _v.component;
        if (('change' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,6).onChange($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,6).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_2:any = ((<any>(_co.activeScenario = $event)) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i1.SelectControlValueAccessor,
          [i0.Renderer2,i0.ElementRef],(null as any),(null as any)),i0.ɵprd(1024,(null as any),
          i1.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i1.SelectControlValueAccessor]),i0.ɵdid(671744,(null as any),0,i1.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i1.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i1.NgControl,(null as any),[i1.NgModel]),i0.ɵdid(16384,(null as any),0,i1.NgControlStatus,
          [i1.NgControl],(null as any),(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n		'])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_ScenarioComponent_1)),i0.ɵdid(802816,(null as any),0,i3.NgForOf,[i0.ViewContainerRef,
          i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵted((null as any),['\n\n	'])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'button',[['class','button']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.ScenarioComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onChangeScenario()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' Select '])),
      (_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n\n	'])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),4,'div',[['style','margin-top: 2px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['\n		Description: '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),1,
          'i',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['',''])),(_l()(),i0.ɵted((null as any),
          ['\n	'])),(_l()(),i0.ɵted((null as any),['\n\n	'])),(_l()(),i0.ɵted((null as any),
          ['\n\n'])),(_l()(),i0.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i2.ScenarioComponent = _v.component;
    const currVal_7:any = _co.activeScenario;
    _ck(_v,8,0,currVal_7);
    const currVal_8:any = _co.scenarios;
    _ck(_v,13,0,currVal_8);
  },(_ck,_v) => {
    var _co:i2.ScenarioComponent = _v.component;
    const currVal_0:any = i0.ɵnov(_v,10).ngClassUntouched;
    const currVal_1:any = i0.ɵnov(_v,10).ngClassTouched;
    const currVal_2:any = i0.ɵnov(_v,10).ngClassPristine;
    const currVal_3:any = i0.ɵnov(_v,10).ngClassDirty;
    const currVal_4:any = i0.ɵnov(_v,10).ngClassValid;
    const currVal_5:any = i0.ɵnov(_v,10).ngClassInvalid;
    const currVal_6:any = i0.ɵnov(_v,10).ngClassPending;
    _ck(_v,5,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_9:any = _co.activeScenario.getDescription();
    _ck(_v,24,0,currVal_9);
  });
}
export function View_ScenarioComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'websph-settings-scenario',
      ([] as any[]),(null as any),(null as any),(null as any),View_ScenarioComponent_0,
      RenderType_ScenarioComponent)),i0.ɵdid(49152,(null as any),0,i2.ScenarioComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const ScenarioComponentNgFactory:i0.ComponentFactory<i2.ScenarioComponent> = i0.ɵccf('websph-settings-scenario',
    i2.ScenarioComponent,View_ScenarioComponent_Host_0,{},{changeScenarioNotify:'changeScenarioNotify'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// D:/[Projects]/WebSPH.gits/WebSPH.git/src/$$_gendir/ui/settings/scenario.component.ngfactory.ts